// 导入合并reducer的依赖
import { combineReducers } from 'redux'

// 导入 登录 模块的 reducer
import A0Layout from './layout'
import three from './three'

// 合并 reducer
const rootReducer = combineReducers({
  A0Layout,
  three
})

// 默认导出
export default rootReducer
